import React, {useEffect, useState} from 'react';
import {FlatList, Platform, StyleSheet, View} from 'react-native';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import RewardMoreWaysToEarnView from 'src/components/elements/rewards/RewardMoreWaysToEarnView';
import AccountStore from 'src/stores/AccountStore';
import Util from 'src/Util';
import ActionsFactory from 'src/actions/ActionsFactory';
import AVText from 'src/components/elements/AVText';
import Localized from 'src/constants/AppStrings';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import Styles from 'src/components/Styles';

const MoreWaysToEarnRewardScreen = () => {
  const [isAutoFundDisabled, setIsAutoFundDisabled] = useState<boolean | null>(
    null,
  );
  const [storeRefresh, setStoreRefresh] = React.useState(0);
  const [rewardItems, setRewardItems] = React.useState([]);

  useEffect(() => {
    const onChange = () => setStoreRefresh((t) => t + 1);
    AccountStore.addChangeListener(onChange);
    return () => AccountStore.removeChangeListener(onChange);
  }, []);

  const onBirthdayUpdate = () => {
    setRewardItems([
      ...AccountStore.getRewardMoreWaysToEarn(isAutoFundDisabled),
    ]);
    setStoreRefresh(storeRefresh + 1);
    ActionsFactory.getAccountActions().loadRewardStatus(
      AccountStore.getAccountId(),
    );
  };

  useEffect(() => {
    AccountStore.addDOBChangedListener(onBirthdayUpdate);
    return () => AccountStore.removeDOBChangedListener(onBirthdayUpdate);
  }, []);

  useEffect(() => {
    const fetchAutoFundDetails = async (): Promise<void> => {
      try {
        const response =
          await ActionsFactory.getAccountActions().retrieveAutoFund(
            AccountStore.getAccountId(),
            AccountStore.getAccountBalanceId(),
          );
        setIsAutoFundDisabled(response?.isDisabled);
      } catch (error) {
        console.error('Error fetching auto fund details:', error);
      }
    };

    fetchAutoFundDetails();
  }, []);

  const renderMoreWayToEarnItem = ({item, index}) => {
    return (
      <RewardMoreWaysToEarnView
        policyItem={item}
        index={index}
        isAutoFundDisabled={isAutoFundDisabled}
      />
    );
  };

  useEffect(() => {
    setRewardItems(AccountStore.getRewardMoreWaysToEarn(isAutoFundDisabled));
  }, [isAutoFundDisabled, storeRefresh]);

  return (
    <View style={styles.container}>
      <View style={styles.titleHead}>
        <AVText
          style={[
            styles.redeemAvailablity,
            getSnackDescriber()?.snackDetailsBtnFontSTyle(),
          ]}
          accessibilityLabel={
            Localized.Labels.rewards_more_ways_disclaimar_text
          }
          aria-label={Localized.Labels.rewards_more_ways_disclaimar_text}
        >
          {Localized.Labels.rewards_more_ways_disclaimar_text}
        </AVText>
      </View>
      <FlatList
        data={rewardItems}
        renderItem={renderMoreWayToEarnItem}
        numColumns={Util.getNumberOfColumnsInGrid()}
        columnWrapperStyle={styles.listColumn}
        initialNumToRender={6}
        keyExtractor={(item) =>
          `${item.rewardPolicyId}-${item.currentStatus}-${item.redemptionTimes}`
        }
        extraData={storeRefresh}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  listColumn: {
    ...Platform.select({
      web: {
        justifyContent: 'flex-start',
      },
      default: {
        justifyContent: 'space-between',
      },
    }),
  },
  redeemAvailablity: {
    fontSize: Styles.Fonts.f1,
    fontStyle: 'italic',
    fontWeight: '400',
  },
  titleHead: {
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m1,
  },
});

export default withForwardedNavigationParams()(MoreWaysToEarnRewardScreen);
